var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon30Arrwosback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-30-arrwos_back",
    "data-name": "icon-30-arrwos back",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "rgba(29,187,190,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(8142 16208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 20,
    height: 20,
    transform: "translate(-8137 -16203)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M6.942.148a.5.5,0,0,1,.71,0l.2.2A.49.49,0,0,1,8,.708v3.58h7.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H8v3.58a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L.152,7.638a.48.48,0,0,1,0-.7Z",
    transform: "translate(-8119 -16185.712) rotate(180)",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon30Arrwosback);
export default __webpack_public_path__ + "static/media/icon-30-arrwos back.30a5bdd153ee982044c3316bd76ffd94.svg";
export { ForwardRef as ReactComponent };